import React, { useState } from 'react';
import { Button, Divider } from 'antd';
import { useTranslation } from 'react-i18next';
import CommunicationPrefEdit, {  } from '../popups/communicationPrefEdit/CommunicationPrefEdit';
import LanguagePrefEdit, {  } from '../popups/languagePrefEdit/LanguagePrefEdit';
import './CommAndLangSection.scss';
import { MemberProfile } from 'types/dto/profile';
import editIcon from 'assets/images/edit.png';

export interface CommAndLangSectionProps {
  profile?: MemberProfile;
  onSaveCallback?: () => void;
}

const CommAndLangSection: React.FC<CommAndLangSectionProps> = ({ profile, onSaveCallback }) => {
  const { t } = useTranslation('profile');
  const { t: tCommon } = useTranslation('common');

  // State for drawer visibility
  const [isCommunicationPrefEditVisible, setIsCommunicationPrefEditVisible] = useState(false);
  const [isLanguagePrefEditVisible, setIsLanguagePrefEditVisible] = useState(false);

  const handleEdit = (section: string) => {
    // console.log(`Edit ${section}`);
    if (section === 'communication') {
      setIsCommunicationPrefEditVisible(true);
    } else if (section === 'language') {
      setIsLanguagePrefEditVisible(true);
    }
  };

  const handleCommunicationPrefEditClose = () => {
    setIsCommunicationPrefEditVisible(false);
  };

  const handleCommunicationPrefEditSave = async () => {
    setIsCommunicationPrefEditVisible(false);
    onSaveCallback?.();
  };

  const handleLanguagePrefEditClose = () => {
    setIsLanguagePrefEditVisible(false);
  };

  const handleLanguagePrefEditSave = async () => {
    setIsLanguagePrefEditVisible(false);
    onSaveCallback?.();
  };

  return (
    <>
      {/* Communication and Language Preferences Section */}
      <div className="info-section">
        <div className="section-title">{t('communication.title')}</div>

        {/* Communication Preferences */}
        <div className="info-item">
          <div className="info-header">
            <div>{t('communication.preferences')}</div>
            <Button
              type="link"
              icon={<img src={editIcon} className='edit-icon'/>}
              onClick={() => handleEdit('communication')}
              className="edit-button desktop-button"
            >
              {t('communication.edit')}
            </Button>
          </div>
          <div className="info-value">
            {profile?.loyalty_account?.consent_status === '1' ? tCommon('label.receiveUpdatesText') :
              tCommon('label.notReceiveUpdatesText')}
          </div>
          {/* Mobile button - appears below content on mobile */}
          <Button
            type="link"
            icon={<img src={editIcon} className='edit-icon'/>}
            onClick={() => handleEdit('communication')}
            className="edit-button mobile-button"
          >
            {t('communication.edit')}
          </Button>
        </div>

        <Divider className="divider" />

        {/* Preferred Language */}
        <div className="info-item">
          <div className="info-header">
            <div>{t('communication.language')}</div>
            <Button
              type="link"
              icon={<img src={editIcon} className='edit-icon'/>}
              onClick={() => handleEdit('language')}
              className="edit-button desktop-button"
            >
              {t('communication.edit')}
            </Button>
          </div>
          <div className="info-value">
            {profile?.preference.language === 'en' ? t('languagePref.english') : t('languagePref.chinese')}
          </div>
          {/* Mobile button - appears below content on mobile */}
          <Button
            type="link"
            icon={<img src={editIcon} className='edit-icon'/>}
            onClick={() => handleEdit('language')}
            className="edit-button mobile-button"
          >
            {t('communication.edit')}
          </Button>
        </div>
      </div>

      {/* Communication Preference Drawer */}
      <CommunicationPrefEdit
        visible={isCommunicationPrefEditVisible}
        onClose={handleCommunicationPrefEditClose}
        onSave={handleCommunicationPrefEditSave}
        initialPreference={profile?.loyalty_account.consent_status}
      />

      {/* Language Preference Drawer */}
      <LanguagePrefEdit
        profile={profile}
        visible={isLanguagePrefEditVisible}
        onClose={handleLanguagePrefEditClose}
        onSave={handleLanguagePrefEditSave}
      />
    </>
  );
};

export default CommAndLangSection;
